import React from "react"
import ReactDOM from "react-dom/client"
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router"
import { DomainContext, EthereumContext, LayoutContext, PoapContext, TransactionsContext } from "./context"
import { Component as ErrorPage } from "./pages/Error"
import { Component as LayoutPage } from "./pages/Layout"
import { Component as AuthPage } from "./pages/Auth"
import { authLoader } from "./pages/Auth/loader"
import { loader as connectLoader } from "./pages/Connect/loader"
import { walletLoader } from "./pages/Wallet/loader"
import { poapListLoader } from "./pages/PoapList/loader"
import { poapDetailLoader } from "./pages/PoapDetail/loader"
import "./index.css"
import "./i18n.config"

export const ROUTES_IDS = {
  DATA_ROOT: "data-root",
} as const

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="connect" lazy={async () => import("./pages/Connect")} loader={connectLoader} />
      <Route element={<LayoutPage />} errorElement={<ErrorPage />}>
        {/* Rutas públicas */}
        <Route index lazy={async () => import("./pages/PoapList")} loader={poapListLoader} />
        <Route path="poap/:id" lazy={async () => import("./pages/PoapDetail")} loader={poapDetailLoader} />
        {/* Rutas que requieren wallet conectada */}
        <Route element={<AuthPage />} loader={authLoader}>
          <Route path="wallet" lazy={async () => import("./pages/Wallet")} loader={walletLoader} />
        </Route>
      </Route>
    </>,
  ),
)

const App = () => {
  return (
    <React.StrictMode>
      <DomainContext>
        <EthereumContext>
          <LayoutContext>
            <TransactionsContext>
              <PoapContext>
                <RouterProvider router={router} />
              </PoapContext>
            </TransactionsContext>
          </LayoutContext>
        </EthereumContext>
      </DomainContext>
    </React.StrictMode>
  )
}

ReactDOM.createRoot(document.getElementById("root")!).render(<App />)
